import { AddressDetailEmployeeResponse } from '@/types/service-response'
import moment from 'moment'

export class AddressEmployee {
  public constructor (
    readonly id: number | undefined,
    readonly address: number,
    readonly privatAddress: any,  //dotypovat
    readonly name: string,
    readonly firstName: string,
    readonly language: number | undefined,
    readonly title: number | undefined,
    readonly salutation: number | undefined,
    readonly genAddress: string | null,
    readonly genSalutation: string,
    readonly addressLine: string,
    readonly description: string,
    readonly addition: string,
    readonly idMarker: number | undefined,
    readonly mdt: number | undefined,
    readonly department: string,
    readonly supervisor: string,
    readonly office: string,
    readonly assistant: string,
    readonly job: string,
    readonly nickname: string,
    readonly partner: string,
    readonly dateOfBirth: string,
    readonly anniversary: string,
    readonly children: string,
    readonly active: boolean,
    readonly financeRelevance: boolean,
    readonly position: number | undefined,
    readonly businessPhone: string,
    readonly privatePhone: string,
    readonly businessMobile: string,
    readonly privateMobile: string,
    readonly businessMail: string,
    readonly privateMail: string,
  ) {}

  static createFromResponse (responseData: AddressDetailEmployeeResponse[]): Array<AddressEmployee> {
    let result: Array<AddressEmployee> = []
    if (responseData) {
      result = responseData.map((item: AddressDetailEmployeeResponse ) => {
        return new AddressEmployee(
          item.ID ? item.ID : undefined,
          item.Adresse,
          item.PrivatAdresse,
          item.Name,
          item.Vorname,
          item.Sprache ? item.Sprache : undefined,
          item.Titel ? item.Titel : undefined,
          item.Anrede ? item.Anrede : undefined,
          item.GenAdresse,
          item.GenAnrede,
          item.AdressLinie,
          item.Beschreibung,
          item.Zusatz,
          item.IDMarker ? item.IDMarker : undefined,
          item.MDT ? item.MDT : undefined,
          item.Abteilung,
          item.Vorgesetzter,
          item.Buero,
          item.Assistent,
          item.Beruf,
          item.Spitzname,
          item.Partner,
          item.Geburtsdatum ? moment(item.Geburtsdatum , 'DD.MM.YYYY').format('DD.MM.YYYY') : '',
          item.Jahrestag,
          item.Kinder,
          item.Aktiv,
          item.FIBUrelevant,
          item.Funktion ? item.Funktion: undefined,
          item.Telefongeschaeftlich,
          item.Telefonprivat,
          item.Handygeschaeftlich,
          item.Handyprivat,
          item.Mailgeschaeftlich,
          item.Mailprivat
        )
      })
    }
    return result
  }

  static createEmpty (addressId: number): AddressEmployee {
    return new AddressEmployee(
      undefined,
      addressId,
      '',
      '',
      '',
      undefined,
      undefined,
      undefined,
      '',
      '',
      '',
      '',
      '',
      undefined,
      undefined,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      true,
      false,
      undefined,
      '',
      '',
      '',
      '',
      '',
      '',
    )
  }
}
